export enum CompanyType {
  Contractor = 1,
  Client = 2,
  ClientOrContractor = 3
}
